import React, { useEffect, useState } from "react";
import { FALLBACK_IMG_ALT } from "../../constants/fallback";
import FALLBACK_IMG from "../../assets/images/default-thumb.png";
import PropTypes from "prop-types";
import "./fallBackImg.scss";
import { isMobile } from "../../utils/breakPoints";

const FallBackImg = ({
  customClassName,
  fallbackImg,
  fallbackImgMobile,
  fallbackImgAlt,
}) => {
  const [fallbackImgSrc, setFallbackImgSrc] = useState(
    fallbackImg || FALLBACK_IMG
  );

  useEffect(() => {
    if (isMobile() && fallbackImgMobile) {
      setFallbackImgSrc(fallbackImgMobile);
    }
  }, []);

  return (
    <img
      className={`fallback-img ${customClassName}`}
      src={fallbackImgSrc}
      alt={fallbackImgAlt || FALLBACK_IMG_ALT}
      loading="lazy"
    />
  );
};

FallBackImg.propTypes = {
  customClassName: PropTypes.string,
  fallbackImg: PropTypes.string,
  fallbackImgMobile: PropTypes.string,
  fallbackImgAlt: PropTypes.string,
};

export default FallBackImg;
